import React, { useState, useRef, useEffect } from "react";
import SkillsPage from "./Skills";
import "./App.css";

const PersonalDetails = () => {
  const [isHoveringIran, setIsHoveringIran] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setIsHoveringIran(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsHoveringIran(false);
    }, 300); // 300ms delay before hiding
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="container">
      <div className="about-details" style={{ marginTop: "2rem" }}>
        <div>
          <h2 className="subtitle">Personal Details</h2>
          <ul
            style={{ listStyle: "none", padding: 0, margin: 0, color: "#a0a0a0" }}
          >
            <li>
              <strong>Date of Birth:</strong> 1999/12/25
            </li>
            <li>
              <strong>Military Status:</strong> Full Military Exemption
            </li>
            <li>
              <strong>Location:</strong> Mashhad,{" "}
              <span
                className="iran-hover-container"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{ position: "relative", cursor: "pointer" }}
              >
                Iran
                {isHoveringIran && (
                  <span
                    className="cuneiform-tooltip"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <span className="cuneiform-text">𐎱𐎠𐎼𐎿𐎠</span>
                  </span>
                )}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const Languages = () => (
  <div className="container">
    <div className="about-details" style={{ marginTop: "2rem" }}>
      <div>
        <h2 className="subtitle">Languages</h2>
        <ul
          style={{ listStyle: "none", padding: 0, margin: 0, color: "#a0a0a0" }}
        >
          <li>Persian (Farsi)</li>
          <li>English</li>
        </ul>
      </div>
    </div>
  </div>
);

const AboutMe = () => (
  <div className="container">
    <div className="header" style={{ margin: 0  , padding: 0}}>
      <h1 className="title" style={{ margin: 0 }}>
        Danial Mohammadzadeh
      </h1>
      <div className="resume">
        <div className="resumeBotton">
          <a
            href="/Danial_Mohammadzadeh_resume.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download PDF
            <div />
          </a>
        </div>
      </div>
    </div>
    <h2 className="subtitle">Flutter & Golang Developer</h2>
    <p>
      I'm a software developer specializing in Flutter and Golang, building
      fast, secure, and user-friendly applications. I've worked on mobile apps,
      back-end systems, and real-time communication tools.
    </p>
    <hr style={{ marginTop: "4rem" }} />
  </div>
);

const ExperienceFull = () => (
  <div className="container">
    <h2 className="subtitle">Employment History</h2>
    <div>
      <h4>Freelance Developer</h4>
      <p>
        Web Developer & backend developer
        <br />
        Remote | 2024/07 - On Going
      </p>
      <p>
        • Developed diverse mobile applications using Flutter for iOS and
        Android platforms.
        <br /> • Built scalable back-end solutions with Golang, focusing on
        high-performance APIs and security.
        <br /> • Leveraged Git, CI/CD workflows, and monitoring tools to
        maintain reliable, high-quality code.
        <br />
        <br /> Skills: Flutter, Dart, BLoC, Firebase, Sentry, GoRouter, Golang,
        RESTful APIs, PostgreSQL, Sentry, Widget Development, Build Optimization
      </p>
      <div />
      <h4>Sharjeman</h4>
      <p>
        Flutter Developer
        <br />
        Remote | 2023/08 - 2024/07
      </p>
      <p>
        • Developed feature-rich Flutter application with production readiness
        <br /> • Enhanced performance through comprehensive project refactoring.
        <br /> • Improved chat service efficiency and added voice/file messaging
        features.
        <br /> • Managed front-end team, testing, and bug reports.
        <br />
        <br /> Skills: Flutter, Performance Optimization, UX Design, Team
        Management, Testing, Sentry, Firebase, Widget Development
      </p>
      <div />
      <h4>Ernyka Group</h4>
      <p>
        Flutter Developer
        <br />
        On-site | 2023/05 - 2023/07
      </p>
      <p>
        • Ensured app responsiveness on iOS, Android, and tablets.
        <br /> • Prioritized security and optimized build configurations.
        <br /> • Maintained clean code adhering to best practices.
        <br /> • Used design system for visually appealing interfaces.
        <br />
        <br /> Skills: Flutter, Cross-Platform Testing, Build Optimization,
        Clean Code, Design Systems
      </p>
      <div />
      <h4>adsofcanada.ca</h4>
      <p>
        Full Stack Developer
        <br />
        Remote | 2022/02 - Present
      </p>
      <p>
        <h5>DaysPay</h5>
        • An app which assists managers in managing their employees and related
        tasks. <br /> • Developed the Flutter app and designed the backend as a
        microservice using Node.js and golang based on the provided designs.
        <br /> • Collaborated closely with clients, incorporating their feedback
        to continuously update and enhance the app.
        <h5>SCCSA</h5>
        • An app which is designed to simplify the hiring process and facilitate
        effective time and task management for employees. <br /> • Leveraged the
        design system from the previous app and personally designed the user
        interface. <br /> • Implemented the Flutter app and designed the backend
        as a microservice using Node.js to support the app's functionalities.
        <br />
        <br /> Skills: Full Stack Development, Flutter, Node.js, Golang, UI
        Design, Microservices, Cross-Platform Testing, Build Optimization,
        Firebase
      </p>
      <div />
      <h4>Garden of Love</h4>
      <p>
        Backend Developer
        <br />
        Remote | 2022/05 - 2022/10
      </p>
      <p>
        • Developed Golang microservices and AWS Lambda functions.
        <br /> Transitioned from AWS infrastructure optimizing architecture.
        <br /> Created chat system with PostgreSQL and Redis for real-time
        communication.
        <br />
        <br /> Skills: Golang, Microservices, AWS, Lambda, PostgreSQL, Redis,
        Real-Time Communication
      </p>
      <div />
      <h4>Supranium</h4>
      <p>
        Backend Developer & DevOps Engineer
        <br />
        Hybrid | 2022/02 - 2023/05
      </p>
      <p>
        • Contributing to the development of decentralized solutions for
        business owners and companies.
        <br /> • Designing and implementing backend systems and microservices to
        support the decentralized architecture.
        <br /> • Collaborating with the team to ensure flawless integration of
        backend services into the overall system.
        <br /> • Implementing DevOps practices to streamline development
        processes and ensure efficient deployment of software.
        <br />
        <br />
      </p>
      <div />
      <h4>Profile</h4>
      <p>
        Golang Developer & Blockchain Researcher
        <br />
        On-site | 2021/12 - 2022/5
      </p>
      <p>
        • Developed Golang microservices and conducted blockchain research.
        <br /> • Created decentralized solutions for services like authorizer,
        storage, gateway, and databases.
        <br />
        <br /> Skills: Golang, Node.js, Microservices, Blockchain, Decentralized
        Solutions, Research
      </p>
      <div />
      <h4>Freelance Developer</h4>
      <p>
        Web Developer & Backend developer
        <br />
        Remote | 2021/06 - 2022/02
      </p>
      <p>
        • Worked as a freelance developer, building websites using React.js and
        developing backend services for microservices systems.
        <br /> • Successfully integrated backend services with existing
        microservices systems, ensuring smooth operation without any issues.
        <br /> • Collaborated with clients to understand their requirements and
        deliver high-quality websites and services.
      </p>
      <div />
      <h4>Bookmarket</h4>
      <p>
        Full Stack Developer
        <br />
        On-site | 2021/01 - 2021/12
      </p>
      <p>
        • Developed microservice-based backend using Java and Spring Boot
        framework.
        <br /> • Utilized Kafka and Eureka for seamless communication and
        service discovery. <br /> • Worked with MongoDB and Neo4j as databases,
        and Redis for efficient token-based caching. <br /> • Managed servers
        and implemented Docker containers for streamlined microservice
        management.
        <br /> • Assumed the role of DevOps engineer, ensuring smooth deployment
        and operation of the system.
        <br /> • Transitioned to the front-end team, working on Android and iOS
        specific code for encryption and caching.
      </p>
      <div />
      <h4>Myco</h4>
      <p>
        Frontend Developer
        <br />
        On-site | 2020/05 - 2020/09
      </p>
      <p>
        • Joined Myco through a recommendation from one of my college
        professors, kickstarting my professional journey.
        <br /> • Gained valuable experience in teamwork and collaborating
        effectively to deliver applications that aligned with the provided
        designs and were responsive. <br /> • Contributed to the development of
        a cross-platform application using Qt/C++, with a primary focus on the
        Windows platform.
      </p>
      <hr style={{ marginTop: "4rem" }} />
    </div>
  </div>
);

const Experience = () => (
  <div className="container">
    <h2 className="subtitle">Employment History</h2>
    <div>
      <h4>Freelance</h4>
      <p>
        Jul 2024 — On Going, Remote
        <br />
        <ul>
          <li>
            Developed diverse mobile applications using Flutter for iOS and
            Android platforms.
          </li>
          <li>
            Built scalable back-end solutions with Golang, focusing on
            high-performance APIs and security.
          </li>
          <li>
            Leveraged Git, CI/CD workflows, and monitoring tools to maintain
            reliable, high-quality code.
          </li>
        </ul>
        <strong>Skills:</strong> Flutter, Dart, BLoC, Firebase, Sentry,
        GoRouter, Golang, RESTful APIs, PostgreSQL, Widget Development, Build
        Optimization
      </p>
      <div />
      <h4>Flutter Developer, Sharjeman</h4>
      <p>
        Aug 2023 — Jul 2024, Remote, Tehran
        <br />
        <ul>
          <li>
            Developed feature-rich Flutter application with production
            readiness.
          </li>
          <li>
            Enhanced performance through comprehensive project refactoring.
          </li>
          <li>
            Improved chat service efficiency and added voice/file messaging
            features.
          </li>
          <li>Managed front-end team, testing, and bug reports.</li>
        </ul>
        <strong>Skills:</strong> Flutter, Performance Optimization, UX Design,
        Team Management, Testing, Sentry, Firebase, Widget Development
      </p>
      <div />
      <h4>Flutter Developer, Ernyka Group</h4>
      <p>
        May 2023 — Jul 2023, On-Site, Tehran
        <br />
        <ul>
          <li>Ensured app responsiveness on iOS, Android, and tablets.</li>
          <li>Prioritized security and optimized build configurations.</li>
          <li>Maintained clean code adhering to best practices.</li>
          <li>Used design system for visually appealing interfaces.</li>
        </ul>
        <strong>Skills:</strong> Flutter, Cross-Platform Testing, Build
        Optimization, Clean Code, Design Systems
      </p>
      <div />
      <h4>Full Stack Developer, adsofcanada.ca</h4>
      <p>
        Feb 2022 — Jul 2024, Remote, Canada
        <br />
        <ul>
          <li>
            <strong>DaysPay:</strong> Developed Flutter app and back-end with
            Node.js and Golang.
          </li>
          <li>
            <strong>SCCSA:</strong> Designed UI and implemented Flutter app with
            Node.js back-end.
          </li>
        </ul>
        <strong>Skills:</strong> Full Stack Development, Flutter, Node.js,
        Golang, UI Design, Microservices, Cross-Platform Testing, Build
        Optimization, Firebase
      </p>
      <div />
      <h4>Golang Developer, Garden of Love</h4>
      <p>
        May 2022 — Oct 2022, Remote, Tehran
        <br />
        <ul>
          <li>Developed Golang microservices and AWS Lambda functions.</li>
          <li>Transitioned from AWS infrastructure optimizing architecture.</li>
          <li>
            Created chat system with PostgreSQL and Redis for real-time
            communication.
          </li>
        </ul>
        <strong>Skills:</strong> Golang, Microservices, AWS, Lambda, PostgreSQL,
        Redis, Real-Time Communication
      </p>
      <div />
      <h4>Golang Developer & Blockchain Researcher, Profile</h4>
      <p>
        Dec 2021 — May 2022, On-Site, Mashhad
        <br />
        <ul>
          <li>
            Developed Golang microservices and conducted blockchain research.
          </li>
          <li>
            Created decentralized solutions for services like authorizer,
            storage, gateway, and databases.
          </li>
        </ul>
        <strong>Skills:</strong> Golang, Node.js, Microservices, Blockchain,
        Decentralized Solutions, Research
      </p>
      <div />
      <h4>Full Stack Developer, Book Market</h4>
      <p>
        Jan 2021 — Dec 2021, On-Site, Mashhad
        <br />
        <ul>
          <li>
            Developed Java Spring Boot microservices with Kafka and Eureka.
          </li>
          <li>
            Managed databases with MongoDB and Neo4j, implemented Redis caching.
          </li>
          <li>
            Transitioned to front-end, focusing on Android and iOS encryption
            and caching.
          </li>
        </ul>
        <strong>Skills:</strong> Java, Spring Boot, Kafka, Eureka, MongoDB,
        Neo4j, Redis, Encryption, Flutter, Front-End Development
      </p>
    </div>
    <hr style={{ marginTop: "4rem" }} />
  </div>
);

const Education = () => (
  <div className="container">
    <h2 className="subtitle">Education</h2>
    <p>
      <strong>Bachelor of Computer Science</strong>
      <br />
      International University of Imam Reza
      <br />
      Sep 2020 — Jan 2024, Mashhad
    </p>
    <hr style={{ marginTop: "4rem" }} />
  </div>
);

const Skills = () => (
  <div className="container">
    <h2 className="subtitle">Skills</h2>
    <ul>
      <li>Flutter</li>
      <li>Bloc</li>
      <li>GetX</li>
      <li>App Store (iOS)</li>
      <li>Google Play (Android)</li>
      <li>GoRouter</li>
      <li>Figma</li>
      <li>User Experience Design</li>
      <li>Sentry</li>
      <li>Java</li>
      <li>Restful API</li>
      <li>gRPC</li>
      <li>GraphQL</li>
      <li>Test Driven Development</li>
      <li>CI/CD</li>
      <li>Golang</li>
      <li>Python</li>
    </ul>
  </div>
);

const Resume = () => {
  return (
    <div style={{ margin: "20px" }}>
      <AboutMe />
      <ExperienceFull />
      <Education />
      <Skills />
      <PersonalDetails />
      <Languages />
      {/* <SkillsPage /> */}
    </div>
  );
};

export default Resume;
